import environment, { getEnvironmentVariable } from "./environment";
const { shell } = window.require("@electron/remote");

export default function openExternal({ env, url }) {
  if (url) {
    if (environment.isBrowser) window.open(url, "_blank");
    else shell.openExternal(url);
    return;
  }

  let path = getEnvironmentVariable(env);
  if (env === "EMAIL") path = `mailto:${path}`;

  if (environment.isBrowser) window.open(path, "_blank");
  else shell.openExternal(path);
}
